import { render } from "./MessageThreadTable.vue?vue&type=template&id=0e56d6e8&scoped=true"
import script from "./MessageThreadTable.vue?vue&type=script&lang=js"
export * from "./MessageThreadTable.vue?vue&type=script&lang=js"

import "./MessageThreadTable.vue?vue&type=style&index=0&id=0e56d6e8&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e56d6e8"]])

export default __exports__